import { render, staticRenderFns } from "./ResourceDisplay.vue?vue&type=template&id=b70ce8a6&scoped=true"
import script from "./ResourceDisplay.vue?vue&type=script&lang=js"
export * from "./ResourceDisplay.vue?vue&type=script&lang=js"
import style0 from "./ResourceDisplay.vue?vue&type=style&index=0&id=b70ce8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ce8a6",
  null
  
)

export default component.exports